import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
import s from '../../services/allservices.jsx'
import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux'
import LoaderSmall from "../loader/loadersmall.jsx"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router';
import '../../stylesheet/friends.css'
const JSEncrypt = window.JSEncrypt
const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        friendsState: state.getFriendsReducer.friendsState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchFriends() {
            dispatch(
                actions.getFriendsAction()
            )
        }
    })
class AddByCardNo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardNumber: "",
            message: "",
            nickName: "",
            userDetailState: {},
            disabled: true,
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleAccordion = this.handleAccordion.bind(this)
    }

    onChange = (e, value) => this.setState({ [e.target.name]: e.target.value }, () => {
        if (this.state.cardNumber !== "" && this.state.confirmCardNumber !== "" && this.state.nickName !== "") {

            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }

    })
    cancelCourse = () => { 
        setTimeout(function () {
            window.location.reload(1);
            }, 100);
      }
    handleAccordion() {
        // let accord= document.getElementById("accactive")
        // accord.classList.add("active")
    }
    isNumberKey=(e)=>{
        var charCode = e.keyCode;

     //You condition
     if (charCode == 58 ){

        e.preventDefault();

        return false;
     }        
    }
   
    handleBasic(e) {
        this.setState({
            basic: !this.state.basic
        })
    }
    handleSubmit() {
        const { publicKey } = this.props
        this.setState({
            loader: true
        })
        let token = "Token " + localStorage.getItem('token')
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            const state = {
                applicationId: "gmcabs",
                accountId: encrypt.encrypt(localStorage.getItem("accountId")),
                cardNumber: encrypt.encrypt(this.state.cardNumber),
                message: encrypt.encrypt(this.state.message),
                nickName: encrypt.encrypt(this.state.nickName),
                cardDetailsId: ""
            }
            let _this = this
            fetch(s.add_friend + "/?Authorization=" + token, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            _this.setState({
                                loader: false
                            })
                            _this.props.fetchFriends();
                        }
                        else {        
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                     
                            _this.setState({
                                loader: false
                            })                       
                            
                    }
                    })
        }
    }
    render() {
        const { userDetailState} = this.state
        return (
            <div>
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="row">
                    <div className="col-sm-6">
                        <div className="row input-group" >
                            <div className="col-sm-2 input-icon" >
                                {/* <i className="fa fa-credit-card-alt text-dark " aria-hidden="true"></i> */}
                                <img src={creditcardlogo} alt="" />
                            </div>
                            <div className="col-sm-10 nopadding" >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText="Card Account"
                                     type="number"
                                    onInput={(e) => {
                                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 16)
                                    }}
                                    name="cardNumber"
                                    onKeyPress={this.isNumberKey}
                                    maxLength="16"
                                    onChange={this.onChange}
                                    className="my-className no-spinners input-width required"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="row input-group" >
                            <div className="col-sm-2 input-icon" >
                                <img src={creditcardlogo} alt="" />
                            </div>
                            <div className="col-sm-10 nopadding" >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText="Confirm Card Account"
                                    type="text"
                                    maxLength="16"
                                    type="number"
                                    onInput={(e) => {
                                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 16)
                                    }}
                                    onKeyPress={this.isNumberKey}
                                    name="confirmCardNumber"
                                    onChange={this.onChange}
                                    className="my-className input-width required"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="row input-group" >
                            <div className="col-sm-2 input-icon" >
                                <i className="fa fa-user text-dark " aria-hidden="true"></i>
                            </div>
                            <div className="col-sm-10 nopadding" >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText="Nickname"
                                    type="text"
                                    name="nickName"
                                    maxLength="50"
                                    onChange={this.onChange}
                                    className="my-className input-width required"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="col-sm-6">
                        <div className="row input-group" >
                            <div className="col-sm-2 input-icon" >
                                <i className="fa fa-commenting-o text-dark " aria-hidden="true"></i>
                            </div>
                            <div className="col-sm-10 nopadding" >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText={"Message"}
                                    type="text"
                                    name="message"
                                    maxLength="50"
                                    onChange={this.onChange}
                                    className="my-className input-width"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="offset-md-3 col-sm-5 text-right">
                        <RaisedButton
                            label="Add Card Account"
                            style={styles.button}
                            disabled={this.state.disabled}
                            backgroundColor="#333"
                            labelColor="#fff"
                            onClick={this.handleSubmit}
                        />
                    </div>
                    <div className="col-sm-2">
                        <RaisedButton
                            label="Cancel"
                            name="cancelCourse" 
                            value="cancel" 
                            onClick={this.cancelCourse}
                            style={styles.button}
                            backgroundColor="#f5f5f5"
                            labelColor="#333"
                            className="accordionItem close"
                           
                        />
                    </div>
                    {this.state.loader === true &&
                        <div className="col-sm-2" style={{ marginTop: "-17px", width: "30% !mportant" }} >
                            <LoaderSmall />
                        </div>}
                </div>
            </div >
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddByCardNo);


// WEBPACK FOOTER //
// ./src/components/friends/addbycardno.jsx